import script from "./GiftHistoryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftHistoryTable.vue?vue&type=script&setup=true&lang=js"

import "./GiftHistoryTable.vue?vue&type=style&index=0&id=a1d16c24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1d16c24"]])

export default __exports__